import React from 'react';
import { Route } from 'react-router';
import Visione from './pages/visione';
import Khameleon from './pages/khameleon';
import iOSX from './pages/iosx';
import Oblivione from './pages/oblivione';

import './App.css';

function App() {
  return (
    <div>
      <Route exact path="/"
        render={() => 
          <div className="App" style={{height: "100vh", width: "100vw", backgroundColor: "#000000" ,display: "grid", placeItems: "center"}}>
            <font style={{fontSize: "3em", fontWeight: "300", color: "#FFFFFF"}}>Hello</font>
          </div>
        }
      />
      <Route exact path="/visione" component={Visione} />
      <Route exact path="/khameleon" component={Khameleon} />
      <Route exact path="/iosx" component={iOSX} />
      <Route exact path="/oblivione" component={Oblivione} />
    </div>
  );
}

export default App;
